/* globals ga, optimizely, dataLayer */
import cookies from 'js-cookie';
import stringUtil from '../../twig/analytics/string-util';
import VueYoutube from '../../twig/vue/mixins/vue-youtube';
import lightboxHelpers from '../../twig/vue/mixins/helpers/lightbox-helpers';

const gaLabel = 'iPad Point of Sale: Rated #1 by people like you';

function defineMarketoFormType(target) {
  const mktoForm =
    document.querySelector(`.ui-lightbox[for="${target}"] .mktoForm`) ||
    document.querySelector('.move-first-step .mktoForm');
  return mktoForm && mktoForm.className.indexOf('mktoSteps') > -1
    ? 'PSG'
    : 'Web Form';
}

// https://stackoverflow.com/questions/4817029/whats-the-best-way-to-detect-a-touch-screen-device-using-javascript
function isTouchDevice() {
  return (
    'ontouchstart' in window || navigator.maxTouchPoints // works on most browsers
  ); // works on IE10/11 and Surface
}

const lightbox = {
  mixins: [VueYoutube],
  methods: {
    lightboxEvents(obj) {
      const fieldValue = stringUtil.toTitleCase(obj.cta);
      const popupAction = obj.action; // Click, Close, Load
      const popupType = obj.type; // Video, WebForm

      dataLayer.push({ event: 'popup', fieldValue, popupAction, popupType });
    },

    lightboxButtonClick(e, target) {
      let cta;

      if (target === 'lightboxMarketoOptimizely') {
        window.optimizelyVariation = true; // temporary for testing; usually set in optimizely itself
        const optimizelyVariation = !!window.optimizelyVariation;
        const linkText = document
          .getElementById('sk-free-trial')
          .textContent.trim();

        dataLayer.push({
          event: 'navigation',
          navType: 'Main',
          navText: linkText
        });
        optimizely.push(['trackEvent', 'navTest-Click']);
        if (!optimizelyVariation) {
          window.location = '/signup';
          return;
        }
      }

      if (e.target.nodeName === 'IMG') {
        cta = e.target.alt;
      } else if (
        e.target.children[0] &&
        e.target.children[0].nodeName === 'IMG'
      ) {
        cta = e.target.children[0].alt;
      } else {
        cta = e.target.textContent;
      }

      this.$root.lightboxCta = cta.replace(/\n|\s\s/g, '');

      if (target === 'lightboxVideoBlog') {
        if (!this.$root.videoPlayed) {
          this.$root.videoPlayed = true;
          this.lightboxOpen('lightboxVideoBlog', 'Click');
        } else {
          this.lightboxOpen('lightboxMarketoBlog', 'Click');
        }
      } else {
        this.lightboxOpen(target, 'Click');
      }
    },

    isTextInUrl(path, textArray) {
      for (const text of textArray) {
        if (path.indexOf(text) > -1) {
          return true;
        }
      }
      return false;
    },

    getTargetAndCookie() {
      const path = window.location.href;
      const targetAndCookie = {};

      if (
        this.isTextInUrl(path, ['successful-business-ideas-for-small-towns'])
      ) {
        targetAndCookie.target = 'lightboxMarketoPopupGuide';
        targetAndCookie.cookieName = '_sk_blogPopupGuide';
      }

      return targetAndCookie;
    },

    getTargetAndCookieForExitPopup() {
      const path = window.location.href;
      const targetAndCookie = {};

      if (
        this.isTextInUrl(path, ['successful-business-ideas-for-small-towns'])
      ) {
        targetAndCookie.target = 'lightboxMarketoPopupGuide';
        targetAndCookie.cookieName = '_sk_blogPopupGuideExit';
      }

      return targetAndCookie;
    },

    lightboxOpen(target, action) {
      const mktoHeader = document.querySelector(
        `.ui-lightbox[for="${target}"] .mktoHeader h2`
      );
      const mktoH2 = mktoHeader
        ? mktoHeader.textContent.replace(/\n|\s\s/g, '')
        : null;
      this.$root.lightboxCta = this.$root.lightboxCta
        ? this.$root.lightboxCta
        : mktoH2;

      switch (true) {
        case target === 'lightboxMarketoBlog':
          this.$root.lightboxFormType = 'Banner';
          break;

        case target === 'lightboxMarketoPopupExit':
          this.$root.lightboxFormType = 'Exit';
          break;

        case target === 'lightboxMarketoPopupGuide':
          this.$root.lightboxFormType = 'Timer';
          this.$root.lightboxCta = 'Guide - Small Business 101';
          break;

        case target.indexOf('lightboxVideo') > -1:
          this.$root.lightboxFormType = 'Video';
          break;

        case target.indexOf('lightboxMarketoOptimizely') > -1:
          this.$root.lightboxFormType = 'Nav';
          this.lightboxEvents(lightboxHelpers.getLightspeedEvent('Open'));
          break;

        case target.indexOf('lightboxMarketo') > -1:
          this.$root.lightboxFormType = defineMarketoFormType(target);
          break;

        default:
          this.$root.lightboxFormType = 'CTA';
          this.$root.lightboxEventName = 'Closed on ';
      }

      const cta = this.$root.lightboxCta;
      const type = this.$root.lightboxFormType;

      this.lightboxEvents({ action, cta, type });

      this.$root.lightboxToggled = target;
      document.getElementsByTagName('body')[0].style.overflow = 'hidden';
      this.lightboxEscapeKeyPress();

      this.$root.lightboxOnClose =
        target === 'lightboxVideoBlog' ? 'lightboxMarketoBlog' : null;
    },

    lightboxClose() {
      const action = 'Close';
      const type = this.$root.lightboxFormType;
      const currentConfirmation = this.$root.marketoCurrentStepConfirmation;
      const preCTA = this.$root.lightboxCta;
      const cta = currentConfirmation
        ? `${preCTA} ${currentConfirmation}`
        : preCTA;
      this.lightboxEvents({ action, cta, type });
      if (type === 'Nav') {
        this.lightboxEvents(lightboxHelpers.getLightspeedEvent('Close'));
      }
      this.$root.marketoCurrentStepConfirmation = '';

      if (this.$root.lightboxOnClose) {
        this.$root.lightboxCta = null;
        this.lightboxOpen(this.$root.lightboxOnClose, 'Load');
      } else {
        this.$root.lightboxToggled = '';
        document.getElementsByTagName('body')[0].style.overflow = 'visible';
      }

      this.$root.marketoInitialStep = this.$root.marketoCurrentStep;
      this.$root.marketoCurrentStep = '';
      this.$root.marketoStepResumed = false;
    },

    lightboxEscapeKeyPress() {
      if (!this.$root.lightboxEscapeListener) {
        document.addEventListener(
          'keydown',
          (event) => {
            const key = event.which || event.keyCode;
            if (key === 27) {
              this.lightboxClose();
            }
          },
          false
        );
        this.$root.lightboxEscapeListener = true;
      }
    },

    binaryQuoteClick() {
      this.$root.binaryOptionVisible = false;
      optimizely.push(['trackEvent', 'quoteClick']);
    },

    binaryTrialClick() {
      optimizely.push(['trackEvent', 'webTrialClick']);
    },

    lightboxClick(event) {
      const target = event.target;
      const targetTagName = target.tagName;
      let targetClassName;
      if (targetTagName === 'svg' || targetTagName === 'path') {
        targetClassName = target.className.baseVal;
      } else if (targetTagName === 'use') {
        targetClassName = target.parentElement.className.baseVal;
      } else {
        targetClassName = target.className;
      }
      const targetClassNameList = targetClassName.split(' ');
      if (
        window.location.pathname === '/index-b' &&
        this.$root.lightboxToggled === 'lightboxMarketoExit' &&
        event.target.href === `${window.location.origin}/signup`
      ) {
        ga('send', 'event', 'Trial Popup', 'Click', event.target.innerText);
        optimizely.push(['trackEvent', 'trialClick']);
      }

      if (targetClassNameList.indexOf('ui-lightbox-close-text') > -1) {
        ga('send', 'event', 'Trial Popup', 'Click', event.target.innerText);
        optimizely.push(['trackEvent', 'browseClick']);
        this.lightboxClose();
      }

      if (
        targetClassNameList.indexOf('ui-lightbox') > -1 ||
        targetClassNameList.indexOf('ui-lightbox-close') > -1 ||
        targetClassNameList.indexOf('ui-lightbox-close-alt') > -1 ||
        targetClassNameList.indexOf('lightbox__close__icon') > -1
      ) {
        if (
          window.location.pathname === '/index-b' &&
          this.$root.lightboxToggled === 'lightboxMarketoExit'
        ) {
          ga('send', 'event', 'Trial Popup', 'Close', gaLabel);
          optimizely.push(['trackEvent', 'closeClick']);
        }
        this.lightboxClose();
      }
    },

    lightboxIsElementPresent(elem) {
      const elemArray = document.querySelectorAll(elem);
      return elemArray.length;
    },

    /**
     * Attempts to display the popup. If another lightbox or the subscribe to blog dropdown is open
     * will try to display the popup again after the retryInterval has passed
     */
    continuallyAttemptToDisplayPopup(cookieName, target, retryInterval) {
      const twentyYears = 7300; // JS Cookie - 1 is 1 day

      setTimeout(() => {
        const newsletterPopup = setInterval(() => {
          // sanity check to see if cookie somehow was set while we were waiting
          if (cookies.get(cookieName)) {
            clearInterval(newsletterPopup);
            return;
          }

          // check to see if subscribe to email dropdown is being shown
          const navEmailSignupLightbox = document.querySelector(
            '.nav__email-signup__lightbox'
          ).style.display;
          if (navEmailSignupLightbox === 'block') {
            return;
          }

          // check to see if any other lightbox is visible
          let areAllLightboxesHidden = true;
          document.querySelectorAll('.ui-lightbox').forEach((element) => {
            if (element.style.display !== 'none') {
              areAllLightboxesHidden = false;
            }
          });
          if (!areAllLightboxesHidden) {
            return;
          }
          // no other lightboxes are shown so show the lightbox, set the cookie and clear the interval
          this.lightboxOpen(target, 'Load');
          cookies.set(cookieName, true, { expires: twentyYears });
          clearInterval(newsletterPopup);
        }, retryInterval);
      }, 500);
    }
  },
  computed: {
    lightboxPopupExit() {
      const { target, cookieName } = this.getTargetAndCookieForExitPopup();
      // skBlogPopupExit is set via google tag manager
      // if (window.skBlogPopupExit !== true || cookies.get(cookieName)) {
      // touch devices can't trigger exit popup
      if (isTouchDevice() || cookies.get(cookieName)) {
        return false;
      }
      setTimeout(() => {
        const showPopup = (event) => {
          const from = event.relatedTarget || event.toElement;

          if (from && from.nodeName !== 'HTML') {
            return;
          }

          /*
          //previous exit popup
          this.lightboxOpen('lightboxMarketoPopupExit', 'Load');
          const twentyYears = 7300; // JS Cookie - 1 is 1 day
          cookies.set(cookieName, true, { expires: twentyYears });
          */
          this.continuallyAttemptToDisplayPopup(cookieName, target, 100);

          document.removeEventListener('mouseout', showPopup, false);
        };

        document.addEventListener('mouseout', showPopup, false);
      }, 500);

      return true;
    }
  },

  mounted() {
    if (
      window.location.pathname === '/partners/lead' &&
      window.location.href.indexOf('referrer=partner') > -1
    ) {
      this.lightboxOpen('lightboxRedirect', 'Load');
    }
  }
};

export default lightbox;
